import { Toolbar, ToolbarButton, ToolbarGroup } from "@fluentui/react-components";
import { AddRegular, ArrowClockwise24Regular, DeleteRegular, DismissRegular, EditRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";

// Business logic
import { useSelectedUsersContext } from "../context/SelectedUsersContext";

const SitesToolbar = ({ setIsAddOpen, setIsEditOpen, setIsRemoverOpen, setIsInviteOpen }) => {
  const { t } = useTranslation();
  const { value: SelectedUsers, setValue: SetSelectedUsers } = useSelectedUsersContext();
  const queryClient = useQueryClient();

  const handleClickNew = () => {
    setIsAddOpen(true);
  };
  const handleClickEdit = () => setIsEditOpen(true);

  return (
    <Toolbar>
      <ToolbarGroup>
        <ToolbarButton icon={<AddRegular />} aria-label="Add" onClick={handleClickNew}>
          {t("generic.add")}
        </ToolbarButton>
        <ToolbarButton
          disabled={!(SelectedUsers?.length === 1)}
          icon={<EditRegular />}
          aria-label="Edit"
          onClick={handleClickEdit}
        >
          {t("generic.edit")}
        </ToolbarButton>
        <ToolbarButton
          disabled={!(SelectedUsers?.length === 1)}
          icon={<DeleteRegular />}
          aria-label="Delete"
          onClick={() => setIsRemoverOpen(true)}
        >
          {t("generic.delete")}
        </ToolbarButton>
        <ToolbarButton
          icon={<ArrowClockwise24Regular />}
          onClick={() => queryClient?.invalidateQueries({ queryKey: ["users"] })}
        >
          {t("generic.refresh")}
        </ToolbarButton>
        <ToolbarButton
          disabled={!(SelectedUsers?.length > 0)}
          icon={<DismissRegular />}
          onClick={() => SetSelectedUsers([])}
        >
          {t("generic.unselect")}
        </ToolbarButton>
        <ToolbarButton icon={<AddRegular />} aria-label="Invite" onClick={() => setIsInviteOpen(true)}>
          {t("generic.invite")}
        </ToolbarButton>
      </ToolbarGroup>
    </Toolbar>
  );
};

export default SitesToolbar;
